import { Header } from '@portal/features/navigation/Header'
import MainMenu from '@portal/features/navigation/MainMenu'
import MainTabs from '@portal/features/navigation/MainTabs'
import WhatIfPage from '@portal/features/whatif/WhatIfPage'
import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = () => (
  <>
    <Header.Left>
      <MainMenu />
    </Header.Left>
    <Header.Center>
      <MainTabs value="whatif" />
    </Header.Center>
    <WhatIfPage />
  </>
)

export const Route = createFileRoute('/_app/whatif')({
  component: RouteComponent,
})
